import SubmittedBenthicPhotoQuadrat from './SubmittedBenthicPhotoQuadrat'

export default SubmittedBenthicPhotoQuadrat
